/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Help24({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm8.85 1.74c0-1.19.69-1.73 1.59-2.32l.107-.071c.778-.52 1.473-.985 1.473-1.989 0-.74-.49-1.53-1.86-1.53-1.7 0-2.15 1.19-2.22 2.33l-1.88-.18C8.1 7.71 9.42 6 12.21 6c2.13 0 3.73 1.39 3.73 3.24 0 1.63-.81 2.27-1.73 2.89-.111.075-.22.146-.323.214-.724.474-1.237.81-1.237 1.536V14h-1.8v-.26Zm-.17 2.03H13V18h-2.32v-2.23Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
